import mediaFragment from '../fragments/mediaFragment'

export default `
query getContent($first: Int, $after: String) {
  getContent(first: $first, after: $after) {
    nextToken
    items {
      id
      handle
      locale
      globalHandle
      cmsSyncSource
      cmsSyncSourceDomain
      cmsSyncSourceContentId
      type
      indexedAt
      title
      description
      sections
      tags
      fields
      articleLists {
        title
        slug
        locale
        handles
      }
      relatedArticles {
        handle
        title
        blogHandle
        cmsSyncSourceContentId
        locale
        createdAt
        updatedAt
        author {
          firstName
          lastName
          bio
          email
        }
        featuredMedia {
          ${mediaFragment}
        }
        publishDate
        description
        excerpt
        tags
      }
      collectionHandle
      content
      contentHtml
      excerpt
      blogHandle
      featuredMedia {
        ${mediaFragment}
      }
      publishDate
      author {
        firstName
        lastName
        bio
        email
      }
      createdAt
      updatedAt
    }
  }
}`
